import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as firebase from 'firebase';
import { MenuServices } from '../../menu/services';

@Component({
  selector: 'page-anaylitics-menu-combo',
  templateUrl: 'anaylitics-menu-combo.html',
})
export class AnayliticsMenuComboPage {
  menu_uid: any;
  menu_title: string;
  firestore;
  loader_sections_sold: boolean = false;

  constructor(
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public menuSerices: MenuServices) {
    this.firestore = firebase.firestore();

    this.menu_uid = this.navParams.get('menu_uid');
    this.menu_title = this.navParams.get('menu_title');

    this.getAllAnalytics();
    this.getMenuSoldSectionsAnalytics();
  }


  //Analitica informació allergens, categories i foodcost
  async getAllAnalytics() {
    this.getMargeOfMenuCombo();
    this.getTagsOfMenu();
  }

  public tags = [];

  async getTagsOfMenu() {
    const body = new HttpParams()
      .set('uid_menu_combo', this.menu_uid);

    await this.http.post(this.globals.analytics_path + 'bimenucombo/get_tags_of_menu_combo', body).subscribe(async res => {
      this.tags.push(res['tags']);
    });
  }

  public menu_combo_average_max = 0;
  public menu_combo_average_max_percentage = 0;
  public menu_combo_benefit_max = 0;
  public menu_combo_benefit_max_percentage = 0;

  public menu_combo_average_min = 0;
  public menu_combo_average_min_percentage = 0;
  public menu_combo_benefit_min = 0;
  public menu_combo_benefit_min_percentage = 0;

  public menu_combo_average = 0;
  public menu_combo_average_sections = 0;
  public menu_combo_average_percentage = 0;

  public menu_combo_benefit = 0;
  public menu_combo_benefit_percentage = 0;

  public menu_combo_price_extra = 0;
  public menu_combo_price_no_tax = 0;

  public sections = [];

  public menu_combo_no_foodcost = false;
  public menu_combo_no_foodcost_list = [];
  public menu_combo_no_section_elements = false;

  public loader = true;

  async getMargeOfMenuCombo() {
    const body = new HttpParams()
      .set('uid_menu_combo', this.menu_uid);

    await this.http.post(this.globals.analytics_path + 'bimenucombo/get_marge_of_menu_combo', body).subscribe(async res => {

      this.loader = true;
      this.menu_combo_average_max = res['menu_combo_average_max'];
      this.menu_combo_average_max_percentage = res['menu_combo_average_max_percentage'];
      this.menu_combo_benefit_max = res['menu_combo_benefit_max'];
      this.menu_combo_benefit_max_percentage = res['menu_combo_benefit_max_percentage'];

      this.menu_combo_average_min = res['menu_combo_average_min'];
      this.menu_combo_average_min_percentage = res['menu_combo_average_min_percentage'];
      this.menu_combo_benefit_min = res['menu_combo_benefit_min'];
      this.menu_combo_benefit_min_percentage = res['menu_combo_benefit_min_percentage'];

      this.menu_combo_average = res['menu_combo_average'];
      this.menu_combo_average_sections = res['menu_combo_average_sections'];
      this.menu_combo_average_percentage = res['menu_combo_average_percentage'];

      this.menu_combo_benefit = res['menu_combo_benefit'];
      this.menu_combo_benefit_percentage = res['menu_combo_benefit_percentage'];

      this.menu_combo_price_extra = res['menu_combo_price_extra'];
      this.menu_combo_price_no_tax = res['menu_combo_price_no_tax'];

      this.sections = res['sections'];

      this.menu_combo_no_foodcost = res['menu_combo_no_foodcost'];
      this.menu_combo_no_foodcost_list.push(res['menu_combo_no_foodcost_list']);
      this.menu_combo_no_section_elements = res['menu_combo_no_section_elements'];

      this.loader = false;

    });
  }

  getColor(percentatge) {
    if (percentatge <= 33) {
      return "red";
    } else if (percentatge > 33 && percentatge <= 66) {
      return "orange";
    } else {
      return "green";
    }
  }


  menuSoldSections: any = [];
  async getMenuSoldSectionsAnalytics() {
    this.loader_sections_sold = true;
    var orders = [];
    await this.firestore.collection('orders')
      .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('show_kitchen', '==', true)
      .orderBy('created_at', 'desc')
      .get()
      .then((snapshot) => {
        if (snapshot.size > 0) {
          snapshot.forEach((doc) => {
            var data = doc.data();
            data.UID = doc.id;
            //all.push(data);
            if (this.checkIfMenuInOrder(data, this.menu_uid)) {
              orders.push(data);
            }
          });
        }
      });

    var baseMenu = Object.keys(this.menuSerices.menu_tmp.sections).reduce((acc, sectionKey) => {
      const { dish, name, name_ca = '', name_de = '', name_en = '', name_fr = '', name_it = '', order } = this.menuSerices.menu_tmp.sections[sectionKey];
      acc.push({ dish, name, name_ca, name_de, name_en, name_fr, name_it, order });
      return acc;
    }, []);

    this.menuSoldSections = await this.countSoldItems(orders, baseMenu);
    this.loader_sections_sold = false;
  }

  checkIfMenuInOrder(pedido, uidElementToFind) {
    const menuSection = pedido.sections.find(section => section.name === "Menu");
    // Si existe la sección "Menu", buscar dentro de sus elementos si alguno tiene el uid_element deseado
    if (menuSection) {
      return menuSection.list.some(item => item.uid_element === uidElementToFind);
    }
    return false;
  }


  countSoldItems(orders, menuBase) {
    const sectionCount = {};
    // Create a set of valid sections from the menu base for faster lookup
    const validSections = new Set(menuBase.map(baseSection => baseSection.name));
    // Iterate through the orders
    orders.forEach(order => {
      order.sections.forEach(section => {
        const { name: sectionName, list } = section;
        // Check if the section is valid
        if (validSections.has(sectionName)) {
          // Initialize the section in the count object if it doesn't exist
          if (!sectionCount[sectionName]) {
            sectionCount[sectionName] = {};
          }
          // Count the items in the section
          list.forEach(item => {
            const { name: itemName } = item;
            sectionCount[sectionName][itemName] = (sectionCount[sectionName][itemName] || 0) + 1;
          });
        }
      });
    });
    // Convert the sectionCount object into an array and sort the items by quantity
    return Object.keys(sectionCount).reduce((acc, section) => {
      const itemsArray = Object.keys(sectionCount[section])
        .map(name => ({ name, quantity: sectionCount[section][name] }))
        .sort((a, b) => b.quantity - a.quantity); // Sort from highest to lowest quantity

      acc.push({ section, items: itemsArray });
      return acc;
    }, []);
  }


}


// WEBPACK FOOTER //
// ./src/pages/components/anaylitics-menu-combo/anaylitics-menu-combo.ts